import {
  Body1,
  ColorClass,
  FlexBox,
  FontClass,
  PageBody,
  TextButton,
  TextButtonTheme,
} from "ui";
import { PageWithHeaderAndFooter } from "@web/components/containers/PageWithHeaderAndFooter";
import flowersPhoto from "@public/images/about/flowers.jpg";
import chefPhoto from "@public/images/about/chef.jpg";
import housePhoto from "@public/images/about/house.jpg";
import Image from "next/image";
import styles from "./css/AboutPage.module.css";

export function AboutPage() {
  return (
    <PageWithHeaderAndFooter>
      <div>
        <PageBody hasHorizontalPadding header="About">
          <div className={styles.content}>
            <Body1 colorClass={ColorClass.Primary}>
              I started this website after getting into film photography, but
              struggling to buy my first camera. I watched lots of YouTube
              videos, and read a few blogs, but found the number of options
              overwhelming. At the end of the day, I just didn&apos;t understand
              the key differences between different cameras.
              <br />
              <br />
              This website is meant to solve that problem. It lets you easily
              compare cameras and see how they&apos;re similar and different. In
              the future, I hope to add even more functionality to this website,
              like the ability to leave reviews and comments under each
              individual camera. For now, I&apos;m focused on adding more
              cameras to the website.
              <br />
              <br />
              If you have any suggestions for the website, or suggestions on
              which cameras I should add next, feel free to{" "}
              <TextButton
                buttonThemeOrColorClass={TextButtonTheme.Primary}
                display="inline"
                fontClass={FontClass.Body1}
                href="https://t.me/pencilflip"
                type="link_external"
              >
                contact me
              </TextButton>
              !
            </Body1>
            <FlexBox className={styles.images} flexDirection="column" gap={48}>
              <Image
                alt="Flowers"
                className={styles.image}
                src={flowersPhoto}
              />
              <Image alt="Chef" className={styles.image} src={chefPhoto} />
              <Image alt="House" className={styles.image} src={housePhoto} />
            </FlexBox>
          </div>
        </PageBody>
      </div>
    </PageWithHeaderAndFooter>
  );
}
